import React from "react";
import { Box, Container, Typography, Button, Stack } from "@mui/material";
import { motion } from "framer-motion";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";

const MONO   = "'JetBrains Mono', 'Fira Code', ui-monospace, monospace";
const ACCENT = "#E2684A";
const PURPLE = "#7C3AED";
const BG     = "#030014";
const LINE   = "#1E2130";
const INK    = "#E7E9EE";
const INK2   = "#B6BBC6";

const CTASection = () => (
  <Box sx={{
    py: { xs: 15, md: 20 }, textAlign: "center",
    background: `radial-gradient(700px 350px at 50% 50%, rgba(226,104,74,0.10), transparent 60%), ${BG}`,
    borderTop: `1px solid ${LINE}`,
  }}>
    <Container maxWidth="md">
      <motion.div
        initial={{ opacity: 0, y: 22 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-60px" }}
        transition={{ duration: 0.55 }}
      >
        <Typography sx={{
          fontFamily: MONO, fontSize: "12px", letterSpacing: "0.16em",
          textTransform: "uppercase", color: ACCENT, mb: 2,
        }}>
          Ready to Transform Your Enterprise
        </Typography>
        <Typography sx={{
          fontFamily: "'IBM Plex Serif', serif",
          fontSize: { xs: "1.8rem", md: "2.75rem" },
          fontWeight: 600, letterSpacing: "-0.015em", lineHeight: 1.15,
          color: INK, maxWidth: 640, mx: "auto", mb: 2.5,
        }}>
          Your team is already using AI.{" "}
          <Box component="span" sx={{
            background: `linear-gradient(90deg, ${ACCENT} 0%, ${PURPLE} 100%)`,
            WebkitBackgroundClip: "text", WebkitTextFillColor: "transparent",
          }}>
            Help them use it like engineers.
          </Box>
        </Typography>
        <Typography sx={{
          color: INK2, lineHeight: 1.7, maxWidth: 540,
          mx: "auto", fontSize: "1.05rem", mb: 4.5,
        }}>
          Book a 30-minute strategy call. We'll look at one of your use cases,
          identify the three highest-leverage AI targets, and tell you honestly whether
          we're the right partner. No deck. No sales theatre.
        </Typography>
        <Stack direction={{ xs: "column", sm: "row" }} spacing={1.5} justifyContent="center">
          <Button
            variant="contained"
            size="large"
            endIcon={<ArrowForwardIcon />}
            onClick={() => window.location.href = "/contact-us"}
            sx={{ px: 5, py: 1.8, fontSize: "15px" }}
          >
            Schedule a Demo
          </Button>
          <Button
            variant="outlined"
            size="large"
            onClick={() => window.location.href = "/case-studies"}
            sx={{ px: 5, py: 1.8, fontSize: "15px" }}
          >
            View Case Studies →
          </Button>
        </Stack>
      </motion.div>
    </Container>
  </Box>
);

export default CTASection;
